import { Component, HostListener, ElementRef, ChangeDetectorRef, inject } from '@angular/core';
import { LanguageOption, LanguageStateService } from '../services/language-state.service';

@Component({
    selector: 'app-language-selector',
    template: `
    <div class="language-container">
      <button type="button"
        class="language-button"
        (click)="toggleSelect($event)"
        [attr.aria-label]="'Change language'">
        <i class="pi pi-globe cursor-pointer"></i>
      </button>

      @if (isSelectOpen) {
        <div class="language-select">
          <ul class="language-list">
            @for (lang of languages; track lang) {
              <li>
                <button type="button"
                  class="language-option"
                  (click)="changeLanguage(lang.code, $event)">
                  {{lang.label}}
                </button>
              </li>
            }
          </ul>
        </div>
      }
    </div>
    `,
    styles: [`
    .language-container {
      position: relative;
      display: inline-block;
    }

    .language-button {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 0;
    }

    .language-select {
      position: absolute;
      right: 0;
      top: 100%;
      min-width: 150px;
      background-color: white;
      border-radius: 4px;
      border: 1px solid #e0e0e0;
      box-shadow: 0 2px 5px rgba(0,0,0,0.2);
      z-index: 1000;
      margin-top: 0.25rem;
    }

    .language-list {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .language-option {
      width: 100%;
      text-align: left;
      padding: 0.75rem;
      background: transparent;
      border: none;
      cursor: pointer;
      transition: background-color 0.2s;
    }

    .language-option:hover {
      background-color: #f5f5f5;
    }
  `],
    standalone: false
})
export class LanguageSelectorComponent {
  isSelectOpen = false;
  languages: LanguageOption[];
  languageService = inject(LanguageStateService);
  elementRef = inject(ElementRef);
  cdr = inject(ChangeDetectorRef);
  constructor() {
    this.languages = this.languageService.availableLanguages;
  }

  toggleSelect(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.isSelectOpen = !this.isSelectOpen;
    this.cdr.detectChanges(); // Force view update
  }

  changeLanguage(code: string, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.languageService.setLanguage(code);
    this.isSelectOpen = false;
    this.cdr.detectChanges(); // Force view update
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event): void {
    if (this.isSelectOpen && !this.elementRef.nativeElement.contains(event.target)) {
      this.isSelectOpen = false;
      this.cdr.detectChanges(); // Force view update
    }
  }
}
